import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function GetAll(accessToken) {
  return {
    type: Pre.SCENARIO + Actions.ALL,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function Add(model, accessToken) {
  return {
    type: Pre.SCENARIO + Actions.ADD,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function Remove(scenarioId, scenarioUId = "", accessToken) {
  return {
    type: Pre.SCENARIO + Actions.REMOVE,
    payload: { id: scenarioId, uId: scenarioUId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function ToggleEnable(scenarioId, enable, accessToken) {
  return {
    type: Pre.SCENARIO + Actions.TOGGLE_ENABLE,
    payload: {
      id: scenarioId,
      enable,
    },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function RunScenario(scenarioId, scenarioUId, accessToken) {
  return {
    type: Pre.SCENARIO + Actions.RUN,
    payload: { id: scenarioId, uId: scenarioUId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function Update(model, accessToken) {
  return {
    type: Pre.SCENARIO + Actions.UPDATE,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function GetDetails(scenarioId, scenarioUId, accessToken) {
  return {
    type: Pre.SCENARIO + Actions.DETAILS,
    payload: { id: scenarioId, uId: scenarioUId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function clearRunResult() {
  return {
    type: Pre.SCENARIO + Actions.CLEAR_RUN_RESULT,
    socket: { send: false, keepSocket: true },
  };
}
